fragment TestimonialFragment on testimonial_Entry {
  typeHandle
  body
  testimonial
  image {
    url
    title
  }
}
